import { render, staticRenderFns } from "./TextSizeMeasure.vue?vue&type=template&id=478373b8&scoped=true&"
import script from "./TextSizeMeasure.vue?vue&type=script&lang=ts&"
export * from "./TextSizeMeasure.vue?vue&type=script&lang=ts&"
import style0 from "./TextSizeMeasure.vue?vue&type=style&index=0&id=478373b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478373b8",
  null
  
)

export default component.exports